module.exports = __webpack_public_path__ + "8cff7a61b0e2f45c821f3404c099be10.ttf";